import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { HelmetDatoCms } from 'gatsby-source-datocms'
import ContactUs from '../components/ContactUs'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import Menu from '../components/Menu'

export default function Header({ children }) {
  return (
    <StaticQuery
      query={graphql`
        query PortfolioLayoutQuery {
          datoCmsPortfolio {
            seoMetaTags {
              tags
            }
            heroText
            heroBackground {
              fluid(maxWidth: 2560, imgixParams: { fm: "jpg", auto: "compress" }) {
                ...GatsbyDatoCmsFluid
              }
            }
          }
          datoCmsContact {
              ...Contact
          }
        }
      `}
      render={data => (
        <React.Fragment>

          <HelmetDatoCms seo={data.datoCmsPortfolio.seoMetaTags} />
          <Hero heroBackground={data.datoCmsPortfolio.heroBackground} className="portfolio-hero">
            <div
              dangerouslySetInnerHTML={{
                __html: data.datoCmsPortfolio.heroText,
              }} />
          </Hero>

          <div className="no-overflow padding-bottom-big">
                <div>{children}</div>
            
          </div>
        </React.Fragment>
      )}
    />
  )
}
